import React, { useState } from 'react';
import { HiChevronLeft, HiChevronRight, HiStar } from 'react-icons/hi';

const testimonials = [
  {
    name: 'Fatima Rahman',
    role: 'Graduate Student, London',
    text: "Marina helped me craft a UK-standard CV that landed me my first job within weeks of graduating. Her understanding of the job market is exceptional and her guidance was truly invaluable.",
    rating: 5,
  },
  {
    name: 'Arif Hossain',
    role: 'Software Engineer, Manchester',
    text: "The visa processing support I received was outstanding. Marina guided me through every step with patience and expertise. I couldn't have navigated the process without her help.",
    rating: 5,
  },
  {
    name: 'Sarah Mitchell',
    role: 'Marketing Manager, Birmingham',
    text: "Marina's content writing services transformed our company's blog. Her writing is professional, engaging, and always delivered on time. A true professional in every sense.",
    rating: 5,
  },
  {
    name: 'Nadia Akter',
    role: 'Recent Graduate, Bristol',
    text: "From CV writing to career guidance, Marina provided personalised support that made all the difference. She genuinely cares about her clients' success and it shows in her work.",
    rating: 5,
  },
  {
    name: 'David Thompson',
    role: 'IT Consultant, Leeds',
    text: "Marina's technical expertise and attention to detail in software collaboration exceeded my expectations. She delivered high-quality work on time and was a pleasure to work with throughout the project.",
    rating: 5,
  },
  {
    name: 'Priya Sharma',
    role: 'PhD Student, Cambridge',
    text: "As an international student, navigating the UK visa process was daunting. Marina's step-by-step guidance and document review made everything so much clearer. I got my student visa approved without any issues!",
    rating: 5,
  },
  {
    name: 'James Wilson',
    role: 'Small Business Owner, Edinburgh',
    text: "I hired Marina for content writing and was blown away by the quality. Her writing perfectly captured my brand voice and significantly improved our website engagement. Highly recommend!",
    rating: 5,
  },
  {
    name: 'Ayesha Khan',
    role: 'Marketing Executive, Glasgow',
    text: "Marina revamped my CV and LinkedIn profile, and within two weeks I had three job offers. Her insights into what recruiters look for in the UK market are spot-on. Worth every penny!",
    rating: 5,
  },
  {
    name: 'Michael Brown',
    role: 'Data Analyst, Liverpool',
    text: "Working with Marina on my Skilled Worker visa application was seamless. She knew exactly what documents were needed and reviewed everything meticulously. Her UK-based knowledge really made the difference.",
    rating: 5,
  },
  {
    name: 'Zara Ahmed',
    role: 'Graduate Trainee, Nottingham',
    text: "Marina's career guidance helped me transition from university to the professional world with confidence. Her CV writing service highlighted my strengths perfectly and helped me stand out from other graduates.",
    rating: 5,
  },
  {
    name: 'Oliver Davies',
    role: 'Freelance Developer, Cardiff',
    text: "I needed help with flight bookings for a complex multi-city business trip. Marina found me the best deals and handled everything professionally. Saved me both time and money!",
    rating: 5,
  },
  {
    name: 'Amina Hassan',
    role: 'Healthcare Professional, Sheffield',
    text: "Marina helped me secure my spouse visa with clear guidance on financial requirements and documentation. Her compassionate approach and expertise made what could have been a stressful process surprisingly smooth.",
    rating: 5,
  },
  {
    name: 'Thomas Anderson',
    role: 'Project Manager, Oxford',
    text: "Marina's professionalism and dedication are unmatched. She provided exceptional content writing for our marketing campaigns and delivered beyond expectations. Will definitely work with her again!",
    rating: 5,
  },
  {
    name: 'Layla Ibrahim',
    role: 'Masters Student, Newcastle',
    text: "From my initial consultation to final CV delivery, Marina was supportive, responsive, and incredibly knowledgeable. My CV looks professional and has already opened doors for internship opportunities. Thank you!",
    rating: 5,
  },
  {
    name: 'Robert Clarke',
    role: 'Senior Analyst, Southampton',
    text: "Marina's CV writing transformed my job search completely. Her ability to highlight key achievements and tailor content to specific roles is remarkable. Landed my dream position within a month!",
    rating: 5,
  },
  {
    name: 'Fatima Ali',
    role: 'Nurse, Leicester',
    text: "Navigating the healthcare visa process was made easy thanks to Marina. She understood the specific requirements for healthcare professionals and guided me through every document with patience and clarity.",
    rating: 5,
  },
  {
    name: 'Daniel Harper',
    role: 'Digital Marketer, Brighton',
    text: "The content writing Marina provided for our social media campaigns was exceptional. Engagement rates doubled within weeks. Her understanding of digital trends is impressive!",
    rating: 5,
  },
  {
    name: 'Sophia Patel',
    role: 'Engineering Graduate, Coventry',
    text: "Marina helped me create an ATS-optimized CV that actually got through automated systems. I went from zero responses to multiple interviews. Her technical knowledge really shows!",
    rating: 5,
  },
  {
    name: 'Ahmed Rahman',
    role: 'Business Consultant, Reading',
    text: "I needed assistance with my dependent visa application and Marina was absolutely brilliant. She anticipated questions before they arose and prepared me thoroughly for the entire process.",
    rating: 5,
  },
  {
    name: 'Emily Watson',
    role: 'Startup Founder, Plymouth',
    text: "Marina's software collaboration services helped us launch our MVP on time. Her technical skills combined with excellent communication made the entire development process smooth and efficient.",
    rating: 5,
  },
  {
    name: 'Hassan Mahmood',
    role: 'Finance Professional, Aberdeen',
    text: "The flight booking service saved me hundreds of pounds on my business travel. Marina found routes and deals I never would have discovered on my own. Exceptional value!",
    rating: 5,
  },
  {
    name: 'Charlotte Green',
    role: 'HR Manager, Bournemouth',
    text: "We hired Marina for corporate content writing and the quality exceeded all expectations. Professional, timely, and perfectly aligned with our brand voice. A rare find!",
    rating: 5,
  },
  {
    name: 'Ibrahim Osman',
    role: 'Researcher, Durham',
    text: "Marina's guidance on my academic CV was invaluable. She understood the nuances of academic applications and helped me present my research experience effectively. Highly recommended for academics!",
    rating: 5,
  },
  {
    name: 'Jessica Martinez',
    role: 'Product Manager, Bath',
    text: "From initial consultation to final delivery, Marina's professionalism shone through. My LinkedIn profile transformation led to recruiters reaching out within days. Outstanding service!",
    rating: 5,
  },
  {
    name: 'Yusuf Ahmed',
    role: 'Tech Entrepreneur, Dundee',
    text: "Marina's technical background made software collaboration seamless. She speaks both business and tech fluently, which is rare. Our project was delivered ahead of schedule with excellent quality.",
    rating: 5,
  },
  {
    name: 'Hannah Richardson',
    role: 'Teacher, York',
    text: "The career guidance I received was personalized and actionable. Marina helped me transition from teaching to educational technology with a CV that showcased my transferable skills perfectly.",
    rating: 5,
  },
  {
    name: 'Mohammed Siddiqui',
    role: 'Accountant, Preston',
    text: "Marina's expertise in UK visa applications is comprehensive. She handled my skilled worker visa with such efficiency and knowledge that I felt confident throughout the entire process.",
    rating: 5,
  },
  {
    name: 'Lucy Bennett',
    role: 'Communications Officer, Canterbury',
    text: "The content writing Marina delivered for our annual report was professional, engaging, and perfectly pitched. She took complex information and made it accessible. Brilliant work!",
    rating: 5,
  },
  {
    name: 'Abdul Karim',
    role: 'Pharmacy Graduate, Swansea',
    text: "Marina helped me with both my CV and student loan application guidance. Her holistic approach to career support made a stressful time much more manageable. Truly grateful!",
    rating: 5,
  },
  {
    name: 'Rebecca Foster',
    role: 'Sales Director, Exeter',
    text: "I've worked with many CV writers, but Marina stands out. She understood my industry immediately and crafted a CV that positioned me perfectly for C-level roles. Worth every penny!",
    rating: 5,
  },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);

  const next = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const prev = () =>
    setCurrent(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );

  return (
    <section id="testimonials" className="section-padding">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-primary font-medium text-sm tracking-wider uppercase">
            Testimonials
          </span>
          <h2 className="section-title mt-2">
            What My <span className="text-primary">Clients Say</span>
          </h2>
          <p className="section-subtitle">
            Real stories from people I've had the pleasure of helping.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm relative">
            {/* Quote Mark */}
            <div className="absolute top-6 left-8 text-6xl text-primary/10 font-display">
              "
            </div>

            <div className="relative z-10">
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonials[current].rating)].map((_, i) => (
                  <HiStar key={i} className="text-yellow-400 text-xl" />
                ))}
              </div>

              <p className="text-text-light text-lg leading-relaxed mb-8 italic">
                "{testimonials[current].text}"
              </p>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary-light to-accent flex items-center justify-center text-white font-semibold">
                    {testimonials[current].name
                      .split(' ')
                      .map((n) => n[0])
                      .join('')}
                  </div>
                  <div>
                    <h4 className="font-semibold text-text-dark">
                      {testimonials[current].name}
                    </h4>
                    <p className="text-sm text-text-light">
                      {testimonials[current].role}
                    </p>
                  </div>
                </div>

                <div className="flex gap-2">
                  <button
                    onClick={prev}
                    className="w-10 h-10 rounded-full bg-soft-pink flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all duration-300"
                    aria-label="Previous testimonial"
                  >
                    <HiChevronLeft size={20} />
                  </button>
                  <button
                    onClick={next}
                    className="w-10 h-10 rounded-full bg-soft-pink flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-all duration-300"
                    aria-label="Next testimonial"
                  >
                    <HiChevronRight size={20} />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                  current === index
                    ? 'bg-primary w-8'
                    : 'bg-primary/20 hover:bg-primary/40'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
